// Состояние окна «лимит сайтов исчерпан». Открывается перехватчиком ответов 429
// в helpers/base/api.js, payload — объект limit из ответа бэкенда:
// { restricted, daily: { used, limit, resetsAt }, monthly: { used, limit, resetsAt } }, limit -1 = без лимита.
// restricted — сниженный лимит нового недоверенного аккаунта, окно показывает другое описание
export const limits = {
  namespaced: true,
  state: () => ({
    isOpen: false,
    restricted: false,
    daily: null,
    monthly: null,
  }),
  mutations: {
    open(state, limit) {
      state.restricted = Boolean(limit?.restricted)
      state.daily = limit?.daily || null
      state.monthly = limit?.monthly || null
      state.isOpen = true
    },
    close(state) {
      state.isOpen = false
    },
  },
  getters: {
    isOpen: state => state.isOpen,
    restricted: state => state.restricted,
    daily: state => state.daily,
    monthly: state => state.monthly,
  },
}
